import { isValidPrice } from './dynamicPrices';

export function hydrateRequiredPricePlaceholders(card: any, pRsnFee: string) {
  try {
    const reqCalc = card?.pricingData?.requiredCalc;
    const applyRsnFee = card?.pricingData?.useRsnFee;
    const rsnFeeNumLocal = parseFloat(pRsnFee);
    const rsnFeeValid = isValidPrice(String(rsnFeeNumLocal)) && rsnFeeNumLocal > 0;
    const effectiveRsnFee = (applyRsnFee && rsnFeeValid) ? rsnFeeNumLocal : 0;
    if (!reqCalc) {
      return card;
    }
    const valuesMap = reqCalc?.requiredPriceValuesNoRsn || {};
    const rsnKeys = reqCalc?.reqPricePlaceholdersWithRsn || [];

    if (card?.productPrice?.priceCopy?.length) {
      card.productPrice.priceCopy = card.productPrice.priceCopy.map(line => {
        let updatedContent = line?.moddedContent || line?.content || '';
        updatedContent = updatedContent.replace(/\[([A-Za-z0-9]+_req_price)\]/g, (_placehdrMatch, placehdrKey) => {
          const baseVal = valuesMap[placehdrKey];
          if (typeof baseVal !== 'number' || isNaN(baseVal)) {
            return '';
          }
          const needsRsn = rsnKeys.includes(placehdrKey);
          const finalValNum = baseVal + (needsRsn ? effectiveRsnFee : 0);
          return finalValNum.toFixed(2);
        });
        return {
          ...line,
          moddedContent: updatedContent
        };
      });
    }
    return card;
  } catch (e) {
    console.error('[ReqPriceHydration][Error]', {
      packageId: card?.packageId,
      error: e
    });
    return card;
  }
}
